import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, MousePointerClick, FileSearch } from 'lucide-react';
const features = [{
  icon: MessageSquare,
  title: 'Conversations',
  description: 'Automatically ingests context from Slack, Teams, Discord, and email threads without manual entry.',
  color: 'text-blue-500',
  bg: 'bg-blue-500/10'
}, {
  icon: MousePointerClick,
  title: 'Actions',
  description: 'Records workflows across your browser and IDE to understand how you actually get work done.',
  color: 'text-cozy-accent',
  bg: 'bg-cozy-accent/10'
}, {
  icon: FileSearch,
  title: 'Documents',
  description: 'Indexes Notion, Google Drive, and GitHub so your AI always cites the single source of truth.',
  color: 'text-emerald-500',
  bg: 'bg-emerald-500/10'
}];
export function Features() {
  return <section className="py-24 bg-white border-y border-cozy-border" data-id="element-46">
      <div className="max-w-6xl mx-auto px-6" data-id="element-47">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-48">
          <h2 className="font-serif text-4xl md:text-5xl mb-4 text-cozy-text" data-id="element-49">
            Captures everything, everywhere.
          </h2>
          <p className="text-cozy-muted text-lg" data-id="element-50">
            GetCozy runs quietly in the background, building a secure, private
            memory graph of your work life. No more copy-pasting context.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-51">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="p-6 rounded-2xl bg-cozy-bg border border-cozy-border hover:shadow-md transition-shadow" data-id="element-52">
              <div className={`w-12 h-12 rounded-xl ${feature.bg} flex items-center justify-center mb-6`} data-id="element-53">
                <feature.icon className={`w-6 h-6 ${feature.color}`} data-id="element-54" />
              </div>
              <h3 className="text-xl font-medium text-cozy-text mb-2" data-id="element-55">
                {feature.title}
              </h3>
              <p className="text-cozy-muted leading-relaxed" data-id="element-56">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}